import React, { Component } from 'react';
import {Label} from 'react-template'
class LableFormInfo extends Component {
    
    render() {
        // certificado, valor, n_vagas
        return (
            <div>
                <section className='form-info-lable'>

                    {this.props.permissao !== "LIVRE" && this.props.permissao.length > 0 && (
                        <section>
                            <Label basic color='black' title='Permissão' size=".85">
                                {this.props.permissao}
                            </Label>
                        </section>
                    )}

                    {this.props.certificado && (
                        <section>
                            <Label basic color='blue' title='Certificados' size=".85">
                                <i className="fas fa-certificate" aria-hidden="true"></i> certificado
                            </Label>
                        </section>
                    )}

                    {this.props.valor > 0 && (
                        <section>
                            <Label basic color='green' title='Taxa de Inscrição' size=".85">
                                valor: R$ {this.props.valor}
                            </Label>
                        </section>
                    )}

                    {this.props.n_vagas > 0 && (
                        <section>
                            <Label basic color='red' title='Total de Vagas' size=".85">
                                <i className="fas fa-certificate" aria-hidden="true"></i> vagas: {this.props.n_vagas}
                            </Label>
                        </section>
                    )}
                    
                    {this.props.children}
                    <section></section>
                </section>
            </div>
        );
    }
}

export default LableFormInfo;




// WEBPACK FOOTER //
// ./src/components/elements/LableFormInfo.js